import { TC_CARDS } from "@app/components/modals/hepstar-terms-conditions/hepstar-terms-conditions";
import { useAppContext } from "@app/helpers/hooks";
import { useModalActions } from "@app/store/hooks/useModalActions";

export const useHepstarTermsAndConditions = () => {
  const { openModal, closeModal } = useModalActions();
  const { device } = useAppContext();
  const is_fullscreen = device.is_mobile && !device.is_tablet;

  const openHepstarTermsAndConditions = () => {
    return openModal({
      type: "hepstar_terms_and_conditions",
      onClose: () => closeModal("hepstar_terms_and_conditions"),
      cards_closed: is_fullscreen
        ? []
        : [
            TC_CARDS.REQUEST_REFUND,
            TC_CARDS.REQUEST_STATUS,
            TC_CARDS.UNDER_CONDITIONS
          ]
    });
  };

  return openHepstarTermsAndConditions;
};
